module.exports = __webpack_public_path__ + "static/barrel-c8779f9ccd2a5ba93d7d7236cade1c15.png";